<script>
export default {
  name:'BaseBanner1',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'A',
      validator(value) {
        return [
          'A',
          'B',
        ].includes(value)
      },
    },
    className: {
      type: String,
      default: ''
    },
  }
}
</script>
<!-- section template -->
<template>
  <section :class="[$style.baseBanner, $style[`isStyle${type}`]]">
    <div class="container" :class="className">
      <BaseSectionTitle
        :title="title"
        :description="description"
        :class="{ hasSlot: $slots.default }"
        class="baseBanner__title"
      />
      <slot/>
    </div>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
%patternPaw {
  position: absolute;
  width: 142px;
  height: 140px;
  pointer-events: none;
  content: '';
  background-image: url('@assets/images/reservation/pattern-paw.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.baseBanner {
  position: relative;
  padding: 60px 0;
  overflow: hidden;
  background: $color-blue;

  @include max-md {
    padding: 36px 0;
  }

  &.isStyleA {
    &::before {
      @extend %patternPaw;

      bottom: 1rem;
      left: -25px;
      width: 142px;
      height: 140px;
      transform: rotate(10deg);
    }

    &::after {
      @extend %patternPaw;

      right: -50px;
      bottom: -35px;
      width: 181px;
      height: 184px;
      transform: scaleX(-1) rotate(-30deg);

      @include max-md {
        display: none;
      }
    }

    > div {
      position: relative;

      &::before {
        @extend %patternPaw;

        right: 37%;
        bottom: -5rem;
        width: 97px;
        height: 97px;
        transform: rotate(-50deg);
      }

      &::after {
        @extend %patternPaw;

        right: 1rem;
        bottom: -2rem;
        width: 69px;
        height: 70px;
        transform: rotate(-80deg);
      }
    }
  }

  &.isStyleB {
    &::before {
      @extend %patternPaw;

      top: 13%;
      left: 0;
      width: 165px;
      height: 160px;
    }

    &::after {
      @extend %patternPaw;

      right: -31px;
      bottom: 10%;
      width: 130px;
      height: 126px;
      transform: scaleX(-1);
    }
  }

  :global {
    .baseBanner {
      &__title {
        margin-bottom: 0;

        &.hasSlot {
          margin-bottom: 3rem;

          @include max-md {
            margin-bottom: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
